import { sciencePartnerLogo } from '../scienceAssets';

/* Research + industry partners for the science section logo
 * marquee. Each PNG is white-tinted (ink recoloured to pure white on
 * a transparent background) so the marks read as one family over the
 * dark shader. Each logo is sized by optical mass rather than a fixed
 * height: wide wordmarks sit a little shorter, compact emblems and
 * crests a little taller, so they read as visually even. Art resolves
 * from the CDN via sciencePartnerLogo(). */
export interface PartnerLogo {
  id: string;
  src: string;
  alt: string;
  /* display width + height in px (optically balanced, not uniform) */
  width: number;
  height: number;
}

export const SCIENCE_PARTNER_LOGOS: PartnerLogo[] = [
  { id: 'bangor-university', src: sciencePartnerLogo('bangor-university.png'), alt: 'Bangor University', width: 48, height: 56 },
  { id: 'stanford-university', src: sciencePartnerLogo('stanford-university.png'), alt: 'Stanford University', width: 49, height: 56 },
  { id: 'pfizer', src: sciencePartnerLogo('pfizer.png'), alt: 'Pfizer', width: 110, height: 45 },
  { id: 'ut-dallas', src: sciencePartnerLogo('ut-dallas.png'), alt: 'University of Texas at Dallas', width: 89, height: 48 },
  { id: 'iit-madras', src: sciencePartnerLogo('iit-madras.png'), alt: 'IIT Madras', width: 54, height: 54 },
  { id: 'johns-hopkins-aramco', src: sciencePartnerLogo('johns-hopkins-aramco.png'), alt: 'Johns Hopkins Aramco Healthcare', width: 150, height: 42 },
  { id: 'beth-israel-deaconess', src: sciencePartnerLogo('beth-israel-deaconess.png'), alt: 'Beth Israel Deaconess Medical Center', width: 91, height: 47 },
  { id: 'university-of-arizona', src: sciencePartnerLogo('university-of-arizona.png'), alt: 'University of Arizona', width: 57, height: 53 },
  { id: 'unsw', src: sciencePartnerLogo('unsw.png'), alt: 'UNSW Sydney', width: 156, height: 41 },
  { id: 'university-of-adelaide', src: sciencePartnerLogo('university-of-adelaide.png'), alt: 'University of Adelaide', width: 69, height: 51 },
  { id: 'liverpool-john-moores', src: sciencePartnerLogo('liverpool-john-moores.png'), alt: 'Liverpool John Moores University', width: 144, height: 42 },
  { id: 'ivi-rma-global', src: sciencePartnerLogo('ivi-rma-global.png'), alt: 'IVI RMA Global', width: 117, height: 45 },
  { id: 'la-trobe-university', src: sciencePartnerLogo('la-trobe-university.png'), alt: 'La Trobe University', width: 104, height: 70 },
  { id: 'universitat-leipzig', src: sciencePartnerLogo('universitat-leipzig.png'), alt: 'Universitat Leipzig', width: 125, height: 44 },
  { id: 'iit-gandhinagar', src: sciencePartnerLogo('iit-gandhinagar.png'), alt: 'IIT Gandhinagar', width: 54, height: 54 },
  { id: 'lehigh-university', src: sciencePartnerLogo('lehigh-university.png'), alt: 'Lehigh University', width: 184, height: 40 },
  { id: 'university-of-melbourne', src: sciencePartnerLogo('university-of-melbourne.png'), alt: 'University of Melbourne', width: 59, height: 53 },
  { id: 'unilever', src: sciencePartnerLogo('unilever.png'), alt: 'Unilever', width: 50, height: 55 },
];
